/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum LocaleActions {
  FETCH = '[Locale] Fetch',
  SET_CURRENT = '[Locale] Set Current',
  SET_ERROR = '[Locale] Set Error',
}
